<template lang="pug">
    #custom-input-wrapper
        input(:type="type" autocomplete="off")
</template>
<script>
export default {
    name: 'custom-input'
};
</script>
<style lang="sass" scoped>
    #custom-input-wrapper
        width: 100%
        height: 40px
        background: url(~public/images/gzzoc/input.svg) no-repeat top left / 352px 40px
        input
            display: block
            width: 100%
            height: 40px
            line-height: 40px
            background: transparent !important
            border: none
            outline: none
            color: transparent !important
</style>